export type EmbeddingIndex = {
  id: string
  /** Public index name, unique within the project. */
  name: string
  projectId: string
  label: string
  propertyName: string
  modelKey: string
  sourceType?: 'managed' | 'external'
  similarityFunction?: 'cosine' | 'euclidean'
  dimensions: number
  enabled: boolean
  /** 'pending' | 'indexing' | 'ready' | 'error' */
  status: string
  createdAt: string
  updatedAt: string
}

export type CreateEmbeddingIndexParams = {
  name?: string
  label: string
  propertyName: string
}

/**
 * The server's naming rule (platform/core `EMBEDDING_INDEX_NAME_PATTERN`); the
 * server validates again and enforces uniqueness within the project.
 */
export const INDEX_NAME_PATTERN = /^[A-Za-z0-9._:-]{1,64}$/

export type EmbeddingIndexStats = {
  totalRecords: number
  indexedRecords: number
}
